/*
 * @Author: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @Date: 2024-06-04 16:56:01
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-20 11:20:46
 * @FilePath: /front-vps-admin/src/public/store/modules/code_map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import DictionaryAPI from "@/web-framework/api/dictionary.js";
import DatadicAPI from "@/web-framework/api/datadic.js";
const state = {
    dictionaryMap: {}, // MAP类型的数据字典
    datadicMap: {}, // 数据字典缓存
}

const mutations = {
    SET_DICTIONARY: (state, key, dataArray) => {
        state.dictionaryMap[key] = dataArray
    }
}

const actions = {
    /**
     * 获取一个字典
     * @param {*} param0 
     * @param {*} keyArray 
     * @returns 
     */
    getCodes({ commit }, keyArray) {
        return new Promise(async (resolve, reject) => {
            let ret = {};
            let notexit = [];

            keyArray.forEach(key => {
                ret[key] = state.dictionaryMap[key];
                if (!ret[key])
                    notexit.push(key);
            });

            if (notexit.length > 0) {
                let result = await DictionaryAPI.batchLoadCodes(notexit);
                if (result.success && result.data) {
                    for (key in notexit) {
                        ret[key] = result.data[key];
                    }
                }
            }
            resolve(ret);
        });
    },
    getDatadic({ commit }, params) {
        return new Promise(async (resolve, reject) => {
            let ret = {};
            if (state.datadicMap[params.datadicName]) {
                ret = state.datadicMap[params.datadicName];
            } else {
                let result = await DatadicAPI.getDatadic(params.serviceName, params.datadicName);
                if (result.success && result.data && result.data.datadicInfo) {
                    state.datadicMap[params.datadicName] = result.data.datadicInfo;
                    ret = state.datadicMap[params.datadicName];
                }
            }

            // 采用复制的方式返回
            resolve({ ...ret });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}